import * as React from 'react'

import {cn} from '@/lib/utils'
import {topeDeTexto} from '@/lib/campos-texto'
import {AvisoDeTope, useAvisoDeTope} from '@/components/ui/aviso-de-tope'

/** `maxLength` por defecto 256, el mismo tope de `NulFreeModel`: el navegador corta donde cortaría la API.
 * Un `maxLength` explícito gana; los `type` sin texto libre están en `lib/campos-texto.ts`, que lee el gate R10. */
function Input({className, type, maxLength, onPaste, onChange, ...props}: React.ComponentProps<'input'>) {
  const tope = topeDeTexto(type, maxLength)
  const aviso = useAvisoDeTope(tope, props.value)
  const campo = (
    <input
      type={type}
      maxLength={tope}
      onPaste={(e) => {
        aviso.onPaste(e)
        onPaste?.(e)
      }}
      onChange={(e) => {
        aviso.olvidarRecorte()
        onChange?.(e)
      }}
      data-slot="input"
      className={cn(
        'h-9 w-full min-w-0 rounded-lg border border-input bg-card px-3 py-1 text-base transition-colors outline-none file:inline-flex file:h-6 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground hover:border-[color-mix(in_oklch,var(--input),var(--foreground)_18%)] focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:pointer-events-none disabled:cursor-not-allowed disabled:border-border disabled:bg-muted disabled:opacity-70 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 md:text-sm',
        className
      )}
      {...props}
    />
  )
  // Solo los campos largos (≥ 500) se envuelven: el resto conserva el DOM exacto
  // que fijan las líneas base visuales.
  if (aviso.recortadoA === null && aviso.restantes === null) return campo
  return (
    <>
      {campo}
      <AvisoDeTope recortadoA={aviso.recortadoA} restantes={aviso.restantes} />
    </>
  )
}

export {Input}
